// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__bDFa8","heroContent":"hero_heroContent__BAvL5","videoContainer":"hero_videoContainer__g0zxO","video":"hero_video__XXLQG","title":"hero_title__z-l8u"};